import {useContext} from 'react'
import {SalesRepTypeReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import {parseSalesRepTypeReportRow} from '../../parsings'
import SalesRepTypeReportRow from './SalesRepTypeReportRow'
import {SALES_REP_TYPE_REPORT_COLUMNS} from '../../utils'
import {formatPrice} from '../../../../utils/common'

const SalesRepTypeReportTable = () => {
  const {salesRepTypeData, isSalesRepTypeLoading, onSortingChange, filters} =
    useContext(SalesRepTypeReportContext)

  return (
    <DynamicTable
      data={salesRepTypeData}
      sortableColumns={SALES_REP_TYPE_REPORT_COLUMNS}
      loading={isSalesRepTypeLoading}
      TableRow={SalesRepTypeReportRow}
      noDataMessage='No sales rep type reports found'
      filters={filters}
      onSortingChange={onSortingChange}
      tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
      rowParsingFunction={parseSalesRepTypeReportRow}
      tableFooter={({columnTotals}: any) => (
        <tfoot className='border-top border-gray-200 text-dark fw-bolder'>
          <tr>
            <td>TOTAL</td>
            <td>{columnTotals.total_order_count}</td>
            <td>{formatPrice(columnTotals.total_discount, false)}</td>
          </tr>
        </tfoot>
      )}
    />
  )
}

export default SalesRepTypeReportTable
